import { HttpClient } from '@sdir/httpclient/lib/HttpClient';
import { AxiosResponse } from 'axios';
import { DEFAULT_LANG, getCurrentLanguageOutsideProvider } from '../../helpers/languageHelpers';
import { ValidateMeRequest, ValidateMeResult } from './types';

/**
 * Tynn, typet klient for kravtjenesten.
 *
 * `validate-me` finnes ikke i den genererte @sdir/httpclient-pakken ennå, og
 * httpClient-instansen i src/httpclient/index.ts er ikke eksportert. Vi setter
 * derfor opp en egen instans med nøyaktig samme middleware (token + APIM-nøkkel
 * + Accept-Language). Når pakken er regenerert byttes denne filen ut med den
 * genererte klienten.
 */
const clientId = 'mss';
const authority = process.env.REACT_APP_EXTERNALAUTHURL || '';
const baseUrl = process.env.REACT_APP_API_URL;

const certreqHttpClient = new HttpClient(baseUrl);

certreqHttpClient.addAPIMSubscriptionKeyHeader(process.env.REACT_APP_SUBSCRIPTIONKEY);
certreqHttpClient.addOICDAuthorizationHeader(authority, clientId);
certreqHttpClient.addRequestMiddleware((req) => {
  const currentLang = getCurrentLanguageOutsideProvider();
  req.headers = {
    ...req.headers,
    'Accept-Language': req.headers?.['Accept-Language'] || currentLang || DEFAULT_LANG,
  };
  return req;
});

/**
 * Kravvurderingen bor i ApplicationService. Endepunktet er registrert i
 * ApiGroup.Internal, samme APIM-produkt som resten.
 */
export const certreqApiBaseUrl = `${baseUrl}/aps-application-internal`;

/**
 * Validerer innlogget person mot kravtreet til én sertifikatkode.
 * Identiteten tas fra tokenet. Body er valgfri — sendes den, MÅ Content-Type settes.
 */
export const validateMe = (
  certificateCode: string,
  request?: ValidateMeRequest
): Promise<AxiosResponse<ValidateMeResult>> => {
  const url = `${certreqApiBaseUrl}/v1/certificate-requirements/${encodeURIComponent(
    certificateCode
  )}/validate-me`;

  if (!request) {
    return certreqHttpClient.client.post<ValidateMeResult>(url);
  }

  return certreqHttpClient.client.post<ValidateMeResult>(url, request, {
    headers: { 'Content-Type': 'application/json' },
  });
};
